import React from 'react';
import Section from '../../components/common/Section';
import FeatureCards from '../../components/sections/FeatureCards/FeatureCards';
import { Button } from '../../components/common';

/**
 * 功能展示页面
 * 展示产品的各种功能特性
 */
const ProductFeaturesPage: React.FC = () => {
  // 营销功能数据
  const marketingFeatures = [
    {
      id: 'marketing-1',
      title: '会员储值',
      subtitle: '高效营销工具，激励客户储值，快速回笼资金。',
      image: '/assets/images/features/recharge.png'
    },
    {
      id: 'product-3',
      title: '积分抵扣',
      subtitle: '打造会员体系，增强客户粘性，有效促进活跃。',
      image: '/assets/images/features/requirement-management.jpg'
    },
    {
      id: 'product-3',
      title: '优惠券',
      subtitle: '打造会员体系，增强客户粘性，有效促进活跃。',
      image: '/assets/images/features/requirement-management.jpg'
    }
  ];

  // 商品功能数据
  const productFeatures = [
    {
      id: 'product-1',
      title: '商品分享',
      subtitle: '驱动社交裂变，鼓励客户分享，带来更多订单。',
      image: '/assets/images/features/user-research.jpg'
    },
        {
      id: 'marketing-2',
      title: '客户管理',
      subtitle: '精细管理客情，分析用户画像，提升复购留存。',
      image: '/assets/images/features/customer.png'
    }   ,
    {
      id: 'marketing-3',
      title: '商品管理',
      subtitle: '轻松上架商品，批量操作库存，高效管理店铺。',
      image: '/assets/images/features/product.png'
    }
  ];

  // 门店功能数据
  const storeFeatures = [
    {
      id: 'store-1',
      title: '打印',
      subtitle: '快速打印小票，高效处理订单，提升门店效率。',
      image: '/assets/images/features/project-management.jpg'
    },

    {
      id: 'product-2',
      title: '商品配送',
      subtitle: '对接多种运力，灵活设置规则，轻松处理订单。',
      image: '/assets/images/features/requirement-doc.jpg'
    }
  ];

  return (
    <div className="template-showcase-page">
      {/* 页面标题 */}
      <Section
        id="template-header"
        spacing="medium"
        background="white"
        className="border-b border-gray-100"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center py-8 md:py-12">
            <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4">
              功能展示
            </div>
            <h1 className="text-[60px] font-bold text-black mb-4">
              全方位的功能，满足您的所有需求
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              从商品管理到客户营销，我们提供完整的解决方案，助力您的业务高效运转
            </p>
          </div>
        </div>
      </Section>

      {/* 营销功能 */}
      <Section
        id="marketing-features"
        spacing="large"
        background="background"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FeatureCards
            title="营销与客户管理"
            description="提升客户体验，增强用户粘性，促进业务增长"
            features={marketingFeatures}
            isReversed={false}
          />
        </div>
      </Section>

      {/* 商品功能 */}
      <Section
        id="product-features"
        spacing="large"
        background="white"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FeatureCards
            title="商品与配送管理"
            description="全方位商品管理，高效配送系统，提升用户满意度"
            features={productFeatures}
            isReversed={true}
          />
        </div>
      </Section>

      {/* 门店功能 */}
      <Section
        id="store-features"
        spacing="large"
        background="background"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FeatureCards
            title="门店运营工具"
            description="提升门店运营效率，优化订单处理流程"
            features={storeFeatures}
            isReversed={false}
          />
        </div>
      </Section>

      {/* 号召性动作区域 */}
      <Section
        id="template-cta"
        background="white"
        spacing="large"
        className="border-t border-gray-100"
      >
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4">
            开始使用
          </div>
          <h2 className="text-[60px] font-bold mb-6 text-black">准备好提升您的工作效率了吗？</h2>
          <p className="text-gray-600 max-w-3xl mx-auto mb-8 text-lg">
            立即注册，体验我们产品的所有强大功能，让您的团队协作更加高效、便捷
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button size="large">
              免费注册
            </Button>
            <Button variant="secondary" size="large">
              预约演示
            </Button>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default ProductFeaturesPage;